<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      center
      width="600px"
      @close="handlerCancel"
  >


    <el-form ref="form" :model="form" label-width="100px"	v-loading="loading">
			<el-form-item label="地址信息">
			  <el-input type="textarea" v-model="address_text" placeholder="粘贴地址信息，点击智能识别按钮自动识别填充地址信息" clearable></el-input>
				<el-button size="mini" @click="bindExplainAddress">智能识别</el-button>
			</el-form-item>
      <el-form-item label="收货人">
        <el-input v-model="form.name" placeholder="请输入收件人姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="form.phone" placeholder="请输入收件人手机号"></el-input>
      </el-form-item>
      <el-form-item label="省市区">
        <el-cascader
					placeholder="请输入省市区"
        	size="large"
					style="width: 100%;"
        	:options="regionData"
        	v-model="selectedOptions"
        	:props="regionProps"
        	@change="areaChange">
        </el-cascader>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="form.detail" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="原始地址" v-if="original_address">
        <span>{{ original_address }}</span>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
  data() {
    return {
			address_text: '',
			original_address: '',
      form:{
				dd_order_id:'',
				province_id:'',
				city_id:'',
				town_id:'',
				street_id:'',
				detail:'',
				name:'',
				phone:'',
      },
			regionData: [],
			regionProps:{
				value:'id',
				label:'label'
			},
			selectedOptions: [],
      visible: false,
      callback: null,
      title: '',
      func: null,
			loading: true
    }
  },
  mounted() {
  },
	
  methods: {
		...mapActions({
			getRegionData:"order/getRegionData",
			getDdReturnAddressInfo:"ucenter/getDdReturnAddressInfo",
			opEditDdReturnAddress:"ucenter/opEditDdReturnAddress",
			getExplainAddress: "ucenter/getExplainAddress",
		}),
    open(title, dd_order_id, callback) {
      this.title = title;
			this.address_text = '';
      this.form.dd_order_id = dd_order_id;
      this.callback = callback;
      this.initRegionData()
			this.initAddressInfo()
			this.visible = true;
			
    },
		initRegionData(){
			var params = {}
			this.loading = true
			this.getRegionData({data:params,success:(res)=>{
				if(res.code===200){
					this.regionData = res.data
					this.loading = false
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		initAddressInfo(){
			var params = {
				dd_order_id: this.form.dd_order_id
			}
			this.getDdReturnAddressInfo({data:params,success:(res)=>{
				if(res.code===200){
					if(res.data.id){
						const str_dd_order_id = this.form.dd_order_id;
						this.form = res.data
						this.form.dd_order_id = str_dd_order_id;
						this.selectedOptions = [this.form.province_id,this.form.city_id,this.form.town_id,this.form.street_id]
						this.original_address = res.data.address_text
					}else{
						this.form = {
							dd_order_id:this.form.dd_order_id,
							province_id:'',
							city_id:'',
							town_id:'',
							street_id:'',
							detail:'',
							name:'',
							phone:'',
						}
						this.selectedOptions = []
						this.original_address = ''
					}
					
				} else {
					this.$message({message: res.msg,type: 'error'})
				}
			}})
		},
		bindExplainAddress(){
			if(!this.address_text){
				this.$message({message: '请输入地址信息',type: 'error'})
					return;
			}
			this.loading = true
			var params = {
				address_text: this.address_text
			}
			this.getExplainAddress({data:params,success:(res)=>{
				this.loading = false;
				if(res.code===200){
					const str_dd_order_id = this.form.dd_order_id;
					this.form = res.data
					this.form.dd_order_id = str_dd_order_id;
					this.selectedOptions = [this.form.province_id,this.form.city_id,this.form.town_id,this.form.street_id]
				} else {
					this.$message({message: res.msg,type: 'error'})
				}
			}})
		},
		areaChange(value) {
			console.log(value)
			this.form.province_id = value[0]
			this.form.city_id = value[1]
			this.form.town_id = value[2]
			this.form.street_id = value[3]
		},
    handlerConfirm() {
      if(this.loading) return;
			this.loading = true
			this.opEditDdReturnAddress({data:this.form,success:(res)=>{
				this.loading = false
				if(res.code===200){
					this.$message({message: res.msg,type: 'success'})
					this.callback && this.callback();
					this.visible = false;
				} else {
					this.$message({message: res.msg,type: 'error'})
				}
			}})
    },
    handlerCancel() {
		this.visible = false;
		console.log(2222)
		this.$emit('close', {})
    },
  }
}
</script>

<style scoped>

</style>